import { useCallback, useEffect, useState } from "react";

const DEFAULT_HIGHLIGHT_MS = 6000;

/** Destaca um item (ex.: consulta recém-marcada) por alguns segundos. */
export function useTemporaryHighlight(durationMs: number = DEFAULT_HIGHLIGHT_MS) {
  const [highlightedId, setHighlightedId] = useState<string | null>(null);

  useEffect(() => {
    if (!highlightedId) return;
    const timer = window.setTimeout(() => setHighlightedId(null), durationMs);
    return () => window.clearTimeout(timer);
  }, [highlightedId, durationMs]);

  const highlight = useCallback((id?: string) => setHighlightedId(id || null), []);
  return { highlightedId, highlight };
}
